<template>
  <img
    :style="style"
    src="../assets/arrow.png"
    class="next-button"
    alt="next"
  >
</template>

<script>
export default {
  name: "NextButton",
  props: {
    down: Boolean,
    up: Boolean
  },
  computed: {
    style() {
      if (this.down) {
        return "transform: rotate(90deg)";
      } else if (this.up) {
        return "transform: rotate(-90deg)";
      } else {
        return null;
      }
    }
  }
};
</script>

<style>
.next-button {
  cursor: pointer;
  position: fixed;
  right: 15%;
  bottom: 100px;
  width: auto;
  max-height: 80px;
  filter: invert(1);
  z-index: 50;
}

@media screen and (max-width: 991px) {
  .next-button {
    right: 25px;
    bottom: 60px;
    max-height: 50px;
  }
}

@media screen and (max-width: 768px) {
  .next-button {
    right: 20px;
    bottom: 50px;
    max-height: 45px;
  }
}

@media screen and (max-width: 480px) {
  .next-button {
    right: 15px;
    bottom: 40px;
    max-height: 40px;
  }
}

@media screen and (max-height: 500px) and (orientation: landscape) {
  .next-button {
    right: 20px;
    bottom: 20px;
    max-height: 35px;
  }
}
</style>
